import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import { MyVaroContext } from 'features/myVaro/provider/MyVaroContextProvider';
import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';

const Agreement = () => {
  const router = useRouter();
  const { selectedAgreement, setSelectedAgreement } = useContext(MyVaroContext);
  const agreementUrl = selectedAgreement?.url;

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: selectedAgreement?.title,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={() => {
                setSelectedAgreement?.({
                  url: '',
                  title: '',
                });
                router.back();
              }}
            />
          ),
        }}
      />
      {agreementUrl ? <PdfViewer url={agreementUrl} /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
  },
});

export default Agreement;
